import { createClient } from "contentful"

export default createClient({
    // space: process.env.REACT_APP_API_SPACE,
    // accessToken:process.env.REACT_APP_ACCESS_TOKEN
    space: "sqidn4xpelm9",
    accessToken:"58swHWDYJpHzuXEfm3Hci8HKBZeWpLVA_KXEYSkI3rQ"
})